interface PatternExampleProps {
  patternType: 'early_five' | 'top_line' | 'corners' | 'full_house';
}

export function PatternExample({ patternType }: PatternExampleProps) {
  // Define marked indices (row, col) for demonstration
  const getMarkedCells = (): [number, number][] => {
    switch (patternType) {
      case 'top_line':
        return [
          [0, 0], [0, 2], [0, 4], [0, 6], [0, 8]
        ];
      case 'corners':
        return [
          [0, 0], [0, 8], [2, 0], [2, 8]
        ];
      case 'early_five':
        return [
          [0, 2], [0, 6], [1, 1], [1, 8], [2, 4]
        ];
      case 'full_house':
        return [
          [0, 0], [0, 2], [0, 4], [0, 6], [0, 8],
          [1, 1], [1, 3], [1, 5], [1, 7], [1, 8],
          [2, 0], [2, 2], [2, 4], [2, 6], [2, 8]
        ];
      default:
        return [];
    }
  };

  const markedList = getMarkedCells();

  const isMarked = (r: number, c: number) => {
    return markedList.some(([mr, mc]) => mr === r && mc === c);
  };

  // Define whether a cell is a blank cell (0) to match general ticket layouts
  const isBlankCell = (r: number, c: number) => {
    const blankMap: Record<number, number[]> = {
      0: [1, 3, 5, 7],
      1: [0, 2, 4, 6],
      2: [1, 3, 5, 7],
    };
    return blankMap[r]?.includes(c);
  };

  return (
    <div className="flex flex-col items-center select-none w-full max-w-[200px] border border-white/5 bg-slate-950/20 p-2.5 rounded-2xl">
      {/* 3x9 Ticket grid */}
      <div className="grid grid-cols-9 gap-1 w-full bg-slate-950 p-1 rounded-xl border border-white/5 shadow-inner">
        {Array.from({ length: 3 }).map((_, r) =>
          Array.from({ length: 9 }).map((__, c) => {
            const empty = isBlankCell(r, c);
            const marked = isMarked(r, c);

            return (
              <div
                key={`${r}-${c}`}
                className={`aspect-square rounded flex items-center justify-center text-[7px] font-black border transition-all duration-300 ${
                  empty
                    ? 'bg-transparent border-transparent'
                    : marked
                      ? 'bg-purple-600 border-purple-500 text-white shadow-glow'
                      : 'bg-slate-900/60 border-white/2 text-surface-600'
                }`}
              >
                {!empty && (marked ? '✓' : '88')}
              </div>
            );
          })
        )}
      </div>
      <span className="text-[9px] font-black uppercase text-amber-400 mt-2 font-mono">
        {patternType.replace('_', ' ')}
      </span>
    </div>
  );
}
export default PatternExample;
